import { render, staticRenderFns } from "./DivisiPengurus.vue?vue&type=template&id=70670ef0"
import script from "./DivisiPengurus.vue?vue&type=script&lang=js"
export * from "./DivisiPengurus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports